document.addEventListener('DOMContentLoaded', function () {
  const STORAGE_KEY = 'vsWishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateButtons();
    updateWishlistCount();
  }

  function isInWishlist(handle) {
    return getWishlist().some(item => item.handle === handle);
  }

  function toggleWishlist(product) {
    let items = getWishlist();

    const exists = items.find(item => item.handle === product.handle);

    if (exists) {
      items = items.filter(item => item.handle !== product.handle);
    } else {
      items.push(product);
    }

    saveWishlist(items);
  }

  function updateButtons() {
    document.querySelectorAll('[data-vs-wishlist-button]').forEach(button => {
      const handle = button.dataset.handle;
      const active = isInWishlist(handle);

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active);
    });
  }

  function updateWishlistCount() {
    const count = getWishlist().length;

    document.querySelectorAll('[data-vs-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-vs-wishlist-button]');

    if (!button) return;

    event.preventDefault();

    toggleWishlist({
      handle: button.dataset.handle,
      title: button.dataset.title,
      url: button.dataset.url,
      image: button.dataset.image,
      price: button.dataset.price
    });
  });

  updateButtons();
  updateWishlistCount();
});